export function LabSearchMobileIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg aria-hidden xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className="size-3.5" {...props}>
      <circle cx="5.235" cy="5.235" r="3.635" stroke="currentColor" strokeWidth="1.2" />
      <path fill="currentColor" fillRule="evenodd" d="m12.576 13.424-5-5 .849-.848 5 5-.849.848Z" clipRule="evenodd" />
    </svg>
  );
}

export function LabSearchIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg aria-hidden xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className="size-3.5" {...props}>
      <circle cx="5.75" cy="5.75" r="2.42" stroke="currentColor" strokeWidth="1.16" />
      <path fill="currentColor" fillRule="evenodd" d="m10.84 11.66-4-4 .82-.82 4 4-.82.82Z" clipRule="evenodd" />
    </svg>
  );
}
